import {NgModule} from '@angular/core';
import {StoreModule} from '@ngrx/store';

import {AuthModule} from '@intocare/auth';

import {ResidentStatisticsComponent} from './components/resident-statistics/resident-statistics.component';
import {ResidentOverviewComponent} from './containers/resident-overview/resident-overview.component';
import {ResidentStatisticsModel} from './models/resident.statistics.model';
import {reducers} from './reducers';
import {CoreModule} from '../../../core';

@NgModule({
	imports: [CoreModule, StoreModule.forFeature('resident-overview', reducers), AuthModule],
	declarations: [ResidentOverviewComponent, ResidentStatisticsComponent],
	providers: [ResidentStatisticsModel],
	exports: [ResidentOverviewComponent]
})
export class ResidentOverviewModule {}
